import moment from 'moment';
import _ from 'lodash';
import formatCurrency from 'format-currency';

class OverachieversReportController {
  constructor($rootScope, $uibModal, $state, $http) {
    "ngInject";
    this.state = $state;
    this.$http = $http;
    this.queryResult;
    this.$rootScope = $rootScope;
    this.customerFilter = 'all';
    this.contractFilter = 'all';
    this.taskFilter = 'all';
    this.formatCurrency = formatCurrency;

    let self = this;

    this.$http.get(this.$rootScope.apiHost+"/api/reports/overachievers", {withCredentials: true}).then(function (success) {
      self.report = success.data;
      self.queryParams = self.report.filterParameters;
      self.search();
    });

    self.timesheetPeriods = [];
    this.$http.get(this.$rootScope.apiHost+"/api/timesheets/dates", {withCredentials: true}).then(function (response) {
      self.timesheetPeriods = response.data
    });


  }

  search() {
    let self = this;
    this.$http.post(this.$rootScope.apiHost+"/api/reports/overachievers", this.queryParams, {withCredentials: true}).then(function (success) {
      self.queryResult = success.data;
    });
  }




}

export default OverachieversReportController;



// WEBPACK FOOTER //
// ./client/pages/admin/reports/canned-reports/overachievers-report/overachievers-report.controller.js